import { render, staticRenderFns } from "./BsGridFooter.vue?vue&type=template&id=5bc7291e&scoped=true&"
import script from "./BsGridFooter.vue?vue&type=script&lang=js&"
export * from "./BsGridFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7291e",
  null
  
)

export default component.exports